import { CommonModule } from '@angular/common';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { Router, RouterLink } from '@angular/router';
import { DocumentHelper, UserSettings } from 'fakturnia-shared';
import { Subscription } from 'rxjs';
import { DateTime } from 'luxon';
import { settings } from 'environments/environment';
import { IncomeChartComponent } from 'shared/components/income-chart/income-chart.component';
import { AnnouncementsListComponent } from 'shared/components/announcements/announcements-list.component';
import { IncomeExpenseTabsComponent } from 'shared/components/income-expense-tabs/income-expense-tabs.component';
import { KsefSetupAlertComponent } from 'shared/components/ksef-setup-alert/ksef-setup-alert.component';
import { PrintManyDialogComponent } from 'shared/dialogs/print-many-dialog/print-many-dialog.component';
import { DataSynchronizerService } from 'shared/services/data-synchronization.service';
import { DocumentsService } from 'shared/services/documents.service';
import { GuidedTourService } from 'shared/services/guided-tour.service';
import { SettingsService } from 'shared/services/settings.service';
import { SynchronizationService } from 'shared/services/synchronization.service';

@Component({
  standalone: true,
  imports: [CommonModule, RouterLink, AnnouncementsListComponent, IncomeChartComponent, IncomeExpenseTabsComponent, KsefSetupAlertComponent, MatIconModule, MatButtonModule],
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit, OnDestroy {

  private _subscriptions: Subscription[] = [];
  private _userSettings: UserSettings | null = null;
  
  incomeCount = 0;
  expenseCount = 0;

  constructor(
    private _dialog: MatDialog,
    private _router: Router,
    private _guidedTourService: GuidedTourService,
    private _synchronizationService: SynchronizationService,
    private _documentsService: DocumentsService,
    private _dataSynchronizerService: DataSynchronizerService,
    private _settingsService: SettingsService
  )
  { }

  ngOnInit(): void {
    this._synchronizationService.synchronize();
    this._calculateCounts();
    
    this._subscriptions.push(
      this._dataSynchronizerService.currentData.subscribe({
        next: (data) => {
          if (data?.table === 'documents') {
            this._calculateCounts();
          }
        }
      })
    );

    this._subscriptions.push(
      this._settingsService.currentUserSettings.subscribe((us: UserSettings) => {
        this._userSettings = us;
      })
    );
  }

  startTour(): void {
    this._guidedTourService.start();
  }

  ngOnDestroy(): void {
    this._subscriptions.forEach(sub => sub.unsubscribe());
  }

  private _calculateCounts(): void {
    this._subscriptions.push(
      this._documentsService.getAll().subscribe({
        next: (result: any) => {
          if (!result?.documents) return;
          const documents = (Object.values(result.documents) as any[]).filter(doc => !doc.isDeleted);
          this.incomeCount = documents.filter(doc => DocumentHelper.getDirection(doc) === 'income').length;
          this.expenseCount = documents.filter(doc => DocumentHelper.getDirection(doc) === 'expense').length;
        }
      })
    );
  }

  showPrintManyDialog() {
    if (settings.enableSubscriptions && this._userSettings?.subscription?.validUntil) {
      if (DateTime.fromISO(this._userSettings.subscription.validUntil) < DateTime.now()) {
        this._router.navigate(['/konto/subskrypcje']);
        return;
      }
    }
    this._dialog.open(PrintManyDialogComponent, {
      width: '500px',
      panelClass: 'fakturnia-responsive-dialog'
    })
  }
  
}
